export const GoogleMapApiOptions = {
    libraries: ['places', 'geometry', 'drawing', 'visualization', 'marker', 'core'],
    v: 'weekly',
    mapIds: ['DEMO_MAP_ID'] // Required for AdvancedMarkerElement
};